export class FooterCta {
    el;
    footerInView;
    constructor(el) {
        this.el = el;
        this.footerInView = false;
        window.addEventListener('scroll', () => {
            this.haveWeScrolled();
        });
    }
    haveWeScrolled() {
        const scrolled = window.pageYOffset > 100;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const _this = this;
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                _this.footerInView = entry.intersectionRatio > 0;
            });
        });
        observer.observe(document.getElementById('site-footer'));
        if (this.footerInView) {
            this.el.classList.add('animate-fade-out-down-10');
            this.el.classList.remove('animate-fade-in-up-75');
            console.log('bottom');
        }
        else if (scrolled) {
            this.el.classList.add('animate-fade-in-up-75');
            this.el.classList.remove('animate-fade-out-down-10');
        }
        else {
            this.el.classList.add('animate-fade-out-down-10');
            this.el.classList.remove('animate-fade-in-up-75');
        }
        return scrolled;
    }
}
